module.exports = __webpack_public_path__ + "static/media/font.c6e0bfe0.svg";